import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { baseNewAndDetailClasses, popupClasses } from './constants';

export default function EntityDetailPopup(props) {
  const {
    loading = false,
    modalMaxWidth = '860px',
    onClose,
    onSaveClick = () => console.log('Save Details'),
    onValidateClick = () => console.log('Validate Details'), // New validation handler
    open = false,
    otherEntityModalPaperProps = {},
    toDisableSave = false,
    toDisableValidate = false,
    toShowSave = true,
    toShowValidate = false, // New prop to toggle Validate button
    toShowCreate = false,
    headContentText = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
    saveText = 'Save',
    validateText = 'Validate',
    otherBaseClasses = {},
    createText = 'Create',
    title = '',
    currDarkThemeClass = '',
    children,
    className,
  } = props;

  const handleSubmit = event => {
    event.preventDefault();
    event.stopPropagation();
    if (toShowSave) onSaveClick(event);
  };

  const handleValidate = event => {
    event.preventDefault();
    event.stopPropagation();
    if (toShowValidate) onValidateClick(event);
  };

  const eDPModalProps = {
    className: `${popupClasses?.entityDetail?.modal} ${currDarkThemeClass}`,
    onClose,
    open,
  };

  const eDPPaperProps = {
    className: `${popupClasses?.entityDetail?.paper} ${currDarkThemeClass} customScroll`,
    component: 'form',
    onSubmit: handleSubmit,
    square: true,
    sx: {
      maxWidth: modalMaxWidth,
      ...(!headContentText && { width: '100%' }),
    },
    variant: 'none',
    ...otherEntityModalPaperProps,
  };

  const eDPSaveBtnProps = {
    className: `${popupClasses?.entityDetail?.validateBtn} ${currDarkThemeClass}`,
    disabled: toDisableSave || loading || !toShowSave,
    startIcon: loading && !toDisableValidate && <CircularProgress color="success" size={20} />,
    type: 'submit',
  };

  const eDPCreateBtnProps = {
    className: `${baseNewAndDetailClasses?.createBtn} ${currDarkThemeClass} ${otherBaseClasses?.saveBtn ?? ''}`,
    startIcon: loading && <CircularProgress color="success" size={20} />,
    type: 'submit',
  };

  const eDPValidateBtnProps = {
    className: `${popupClasses?.entityDetail?.validateBtn} ${currDarkThemeClass}`,
    onClick: handleValidate,
    startIcon: loading && <CircularProgress color="success" size={20} />,
    disabled: toDisableValidate || loading,
  };

  return (
    <Modal {...eDPModalProps}>
      <Paper {...eDPPaperProps}>
        <Box className={`${popupClasses?.entityDetail?.closeIconBox} ${currDarkThemeClass}`}>
          <CloseIcon className={`${popupClasses?.entityDetail?.closeIcon} ${currDarkThemeClass}`} onClick={onClose} />
        </Box>
        <Paper className={`${popupClasses?.entityDetail?.headerPaper} ${currDarkThemeClass}`} square>
          <Typography className={`${popupClasses?.entityDetail?.titleTypo} ${currDarkThemeClass}`}>{title}</Typography>
          <Paper className={`${popupClasses?.entityDetail?.headContentPaper} ${currDarkThemeClass}`} square>
            <Typography className={`${popupClasses?.entityDetail?.headContentTypo} ${currDarkThemeClass}`}>{headContentText}</Typography>
            <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
              {toShowSave && (
                <Button {...eDPSaveBtnProps} variant="contained">
                  {saveText}
                </Button>
              )}
              {toShowValidate && (
                <Button {...eDPValidateBtnProps} style={{ marginLeft: '20px', fontWeight: 'bolder' }} variant="outlined">
                  {validateText}
                </Button>
              )}
            </Box>
          </Paper>
        </Paper>
        {children}
        <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {toShowCreate && (
            <Button {...eDPCreateBtnProps} variant="contained">
              {createText}
            </Button>
          )}
        </Box>
      </Paper>
    </Modal>
  );
}
